import {Account, AccountType} from '../../components/Search/SearchNav/types';
import {UsageType} from '../../generated/graphql';
import {
  getIntervalMarkersFromCurrentCalendarMonth,
  useGetUsageThisBillingPeriod,
} from './utils';

export function useGetTrainingUsageDetails(selectedAccount: Account | null) {
  const skip =
    selectedAccount?.name == null ||
    selectedAccount?.accountType === AccountType.Personal;

  const usagePeriod = getIntervalMarkersFromCurrentCalendarMonth();

  const usageResults = useGetUsageThisBillingPeriod(
    selectedAccount,
    UsageType.TrainingDuration,
    usagePeriod,
    skip
  );

  const loading = usageResults.loading;
  const error = usageResults.error;
  const [billingPeriodStart, billingPeriodEnd] = usagePeriod;
  const {usage} = usageResults;

  return {
    billingPeriodStart,
    billingPeriodEnd,
    usage,
    loading,
    error,
  };
}
